import React, { useState, useEffect } from 'react';
import { useMaintenanceModel } from "../chargebackModel";
import { YhPrint } from "@/components/YhPrint";
import { chargebackService } from '../chargebackService';
import { IItemDetailList, IMaterialDetailList, IChargebackDetail } from '../chargebackTypes';
import { formatNum, formatIntPoint, numberParseChina } from '@/utils/utils';
import moment from 'moment';
import useGlobalModel from '@/model/globalModel';
import zh_CN from '@/locale/zh-CN';
import en_US from '@/locale/en-US';
export type IChargebackAndItemType = {
    total: number
    discount: number
}

export function Print() {
    const initDesc = { total: 0, discount: 0 }
    const { print, setPrint, onPrinting, selectedRow } = useMaintenanceModel();
    const [formVal, setFormVal] = useState<IChargebackDetail>();
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IChargebackAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IChargebackAndItemType>(initDesc);
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { CustomerData, technicianData, vehicleData, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    useEffect(() => {
        print && getPoDetailOne()
    }, [print])

    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await chargebackService.one(selectedRow.returnCode as string);
        let { itemDetails, materialDetails, ...formVal } = retData;
        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }

        let newItemDetails = itemDetails?.map((item, index) => {
            newItemTotal.total += Number(item.workHour) * Number(item.price)
            newItemTotal.discount = item.discountRate as number
            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.workHour) * Number(item.price)
            }
        })
        let newMaterialDetails = materialDetails?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate as number
            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price)
            }
        })
        if (retData) {
            console.log(newItemTotal)
            setMaintenanceList(newMaterialDetails as IChargebackDetail[] ?? []);
            setItemList(newItemDetails as IChargebackDetail[] ?? []);
            setFormVal(formVal)
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };

    const columns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            title: 'PART NO零件号 رقم القطع',
            dataIndex: 'materialCode',
        },
        {
            title: 'Description零件名称 أسم القطع ',
            dataIndex: 'materialName',
        },
        {
            title: 'Quantity数量 كيمة  ',
            dataIndex: 'num',
        },
        {
            title: 'Unit price单价  SR أسعار ',
            dataIndex: 'price',
        },
        {
            title: ' Amount总价 أجمالي ',
            dataIndex: 'notAmount',
        }
    ]
    const itemClumns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            title: '项目编码',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '工时',
            dataIndex: 'workHour',
        },
        {
            title: 'Unit price单价  SR أسعار ',
            dataIndex: 'price',
        },
        {
            title: ' Amount总价 أجمالي ',
            dataIndex: 'notAmount',
        }
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "VAT NO增值税号",
                fieldValue: " "
            },
            {
                fieldLabel: "单据编号",
                fieldValue: formVal?.returnCode,
            },
            {
                fieldLabel: "CUSTOMER NAME 顾客姓名: اسم العميل",
                fieldValue: formVal?.customerName,
                border: true,
            },
            {
                fieldLabel: "INVOICE DATE发票日期:  التاريخ",
                fieldValue: moment(formVal?.createTime).format("DD/MM/YYYY"),
                border: true,
            },
            {
                fieldLabel: "地址 العنوان",
                fieldValue: formVal?.customerAddress,
                border: true,
            },
            {
                fieldLabel: "车辆类型",
                fieldValue: formVal?.vehicleTypeName,
                border: true,
            },
            {
                fieldLabel: "车辆牌照",
                fieldValue: formVal?.licensePlate,
                border: true,
            },
            {
                fieldLabel: "VIN码",
                fieldValue: formVal?.vin,
                border: true,
            },
            {
                fieldLabel: "维修类型",
                fieldValue: formVal?.serviceTypeName,
                border: true,
            },
            {
                fieldLabel: "进厂时间",
                fieldValue: formVal?.enterTime,//? moment(formVal?.enterTime).format("DD/MM/YYYY") : "",
                border: true,
            },
            {
                fieldLabel: "出厂时间",
                fieldValue: formVal?.deliveryTime,//? moment(formVal?.deliveryTime).format("DD/MM/YYYY") : "",
                border: true,
            },
        ],
        footer: [
            {
                fieldLabel: "Prepared",
                fieldValue: ""
            },
            {
                fieldLabel: "Prepared",
                fieldValue: ""
            },
            {
                fieldLabel: "Approved批准",
                fieldValue: ""
            },
        ],
        totalAmount: [
            {
                fieldLabel: "SUBTOTAL合计金额 اجمالي",
                fieldValue: maintenanceTotal.total,
            },
            {
                // fieldLabel:(100 - maintenanceTotal.discount) + "%"+"DISCOUN折扣 الخصم",
                fieldLabel: " الخصم DISCOUN折扣 " + (100 - maintenanceTotal.discount) + "%",
                fieldValue: maintenanceTotal.total - maintenanceTotal.total * (maintenanceTotal.discount / 100),
                // suffix: "%"
            },
            {
                fieldLabel: "TOTAL 总金额 اجمالي",
                fieldValue: formVal?.materialScienceAmount,
            },
            {
                fieldLabel: "VAT 15%  税费 الضريبة",
                fieldValue: Number(formVal?.materialScienceAmount) * 0.15,
            },
            {
                fieldLabel: " NET TOTAL 最终金额 الصافي",
                fieldValue: Number(formVal?.materialScienceAmount) + Number(formVal?.materialScienceAmount) * 0.15,
            },
            {
                fieldLabel: "",
                fieldValue: "",
                empty: true
            },
            {
                fieldLabel: " 单据最终金额",
                fieldValue: (Number(formVal?.receivableTotalAmount) * 1.15).toFixed(2),
            },
        ],
        itemAmount: [
            {
                fieldLabel: "SUBTOTAL合计金额 اجمالي",
                fieldValue: itemTotal.total,
            },
            {
                // fieldLabel: (100 - itemTotal.discount) + "%", //"DISCOUN折扣 الخصم",
                fieldLabel: " الخصم DISCOUN折扣" + (100 - itemTotal.discount) + "%",
                fieldValue: itemTotal.total - itemTotal.total * (itemTotal.discount / 100),
                // fieldLabel: "DISCOUN折扣 الخصم",
                // fieldValue: itemTotal.discount,
                // suffix: "%"
            },
            {
                fieldLabel: "TOTAL 总金额 اجمالي",
                fieldValue: formVal?.workingHoursAmount,
            },
            {
                fieldLabel: "VAT 15%  税费 الضريبة",
                fieldValue: Number(formVal?.workingHoursAmount) * 0.15,
            },
            {
                fieldLabel: " NET TOTAL 最终金额 الصافي",
                fieldValue: Number(formVal?.workingHoursAmount) + Number(formVal?.workingHoursAmount) * 0.15,
            },
        ]
    }
    const onCancel = () => {
        setPrint(false)
        setMaintenanceList([]);
        setItemList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const onConfirm = async () => {
        // let { id, returnCode } = selectedRow
        // await onPrinting({ id, returnCode })
    }
    return (
        <YhPrint
            title=""
            type=""
            visible={print}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            itemClumns={itemClumns}
            itemDataSource={itemList}
            dataSource={maintenanceList}
            printShow={printShow}
        />
    );
}

export default Print;
